import React, {Component} from 'react';
import Select from "../Select/Select";
import connect from "react-redux/es/connect/connect";
import withRouter from "react-router/es/withRouter";
import {REQUEST_FACILITIES_META_DATA} from "../../actions/facilitiesMetaActions";
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";
import Skeleton from "../Skeleton/Skeleton";

const mapStateToProps = (state) => {
  return {
    facilitiesMeta: state.facilitiesMetaData,
    rawFacilities: state.facilitiesData.rawFacilities
  }
};

const mapDispatchToProps = dispatch => ({
  getFacilitiesMeta: () => dispatch({type: REQUEST_FACILITIES_META_DATA}),
  getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA}),
});

class contactCargoSalesManagerForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      states: [],
      airports: [],
      contacts: []
    }
  }

  componentDidMount() {
    if (!Object.keys(this.props.facilitiesMeta).length > 0) {
      this.props.getFacilitiesMeta();
    }

    if (!this.props.rawFacilities) {
      this.props.getRawFacilities();
    }
  }

  handleCountryChange(countryName) {

    let country = this.props.facilitiesMeta.countries.find(country => {
      return country.country === countryName;
    });

    let states = country.states.map(state => {
      return {
        name: state,
        airports: []
      }
    });


    this.setState({
      states: states,
      airports: [],
      contacts: []
    });

  };

  handleStateChange(stateName) {
    let rawFacilities = this.props.rawFacilities;
    let airports = this.props.facilitiesMeta.facilities.filter(facility => facility.state === stateName).map(facility => {
      let rawFacility = rawFacilities.find(rfacility =>  rfacility.airportCodeIATA === facility.airportCode);
      if (rawFacility) {
        return {
          name: `${rawFacility.commonAirportName.toUpperCase()} (${facility.airportCode})`,
          value: facility.airportCode
        };    
      } else {
        return null; // or handle the case where there's no matching raw facility
      } 
    }).filter(airport => airport !== null);
    this.setState({
      airports: airports,
      contacts: []
    })
  }

  handleAirportChange(airportCode) {

    let contacts = this.props.facilitiesMeta.contacts.filter(meta => {
      return meta.manages.indexOf(airportCode) > -1;
    });

    this.setState({
      contacts: contacts
    });

  }

  getPageView() {

    const countries = this.props.facilitiesMeta.countries ? this.props.facilitiesMeta.countries.map(country => {
      return {
        name: country.country
      }
    }) : [];

    return (
      <div className="contact-section__tab-content">
        <h2 className="contact-us-form-title">Contact your Southwest Cargo Manager</h2>
        <p className="contact-us-form-description">The Southwest Cargo Team is readily available to assist you, and
          ensure
          you have all the information you need for both your shipping and operational needs.</p>
        <div className="contact-sales-input-container">
          <Select
            hasPleaseSelectOption={true}
            name="country"
            title="Country"
            onChange={(event) => {this.handleCountryChange(event.target.value)}}
            options={countries}
            desktopWidth={'100%'}
            tabletWidth={'100%'}
            mobileWidth={'100%'}
          />
        </div>
        <div className="contact-sales-input-container">
          <Select
            hasPleaseSelectOption={true}
            name="state"
            title="State"
            onChange={(event) => {this.handleStateChange(event.target.value)}}
            options={this.state.states}
            resetOnPropsUpdate={true}
            desktopWidth={'100%'}
            tabletWidth={'100%'}
            mobileWidth={'100%'}
          />
        </div>
        <div className="contact-sales-input-container">
          <Select
            hasPleaseSelectOption={true}
            name="airport"
            title="Airport"
            onChange={(event) => {this.handleAirportChange(event.target.value)}}
            options={this.state.airports}
            resetOnPropsUpdate={true}
            desktopWidth={'100%'}
            tabletWidth={'100%'}
            mobileWidth={'100%'}
          />
        </div>
        <div className="mtl">
          <div className="schedules-search-required mtm">
            <span className="tracking-advanced-search-superscript-required-header">*</span>
            <span> Required </span>
          </div>
        {this.state.contacts.map(contact => {
          return (
            <div key={contact.email} className="facility-details__manager mtl">
              <p className="contact-section__info-block-subtitle">{contact.title}</p>
              <p className="contact-sales-name">{contact.name}</p>
              <p className="contact-sales-cell"><a href={"tel:+" + contact.phone}>{contact.phone}</a></p>
              <p className="contact-sales-email"><a href={"mailto:" + contact.email}>{contact.email}</a></p>
            </div>
          )
        })}
        </div>
      </div>
    )
  }

  render() {
    return this.props.facilitiesMeta && this.props.rawFacilities ? this.getPageView() : <Skeleton type="LONG_CONTENT_PAGE"/>;
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(contactCargoSalesManagerForm));



// WEBPACK FOOTER //
// ./src/components/ContactCargoSalesManagerForm/ContactCargoSalesManagerForm.js